import { createContext } from 'react';
import { PwaUpdateContextValue } from './types';

export const PwaUpdateContext = createContext<PwaUpdateContextValue | null>(null);